module.exports = __webpack_public_path__ + "static/media/game_master_345.a35fec3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/game_master_345.jpg
// module id = 227
// module chunks = 0